require('../vendor/jquery.fancybox');
require('../icmib/home/localeSwitcher.jquery');
import * as subscription from '../icmib/home/subscriptions';
import { signUpOnlyIfTerms } from '../icmib/home/sessions';
import {
  buildErrorMessage,
  initUserRegistrationValidation,
  removeErrorMessage,
} from '../icmib/home/validations';
import { initSocialLogin } from '../icmib/home/social_login';

require('../icmib/home');

ICMIB.subscription = subscription;
ICMIB.signUpOnlyIfTerms = signUpOnlyIfTerms;
ICMIB.buildErrorMessage = buildErrorMessage;
ICMIB.removeErrorMessage = removeErrorMessage;
window.initUserRegistrationValidation = initUserRegistrationValidation;
ICMIB.initSocialLogin = initSocialLogin;

ICMIB.t = function(key, subs) {
  if (subs === undefined) return ICMIB.dictionary[key];
  else return ICMIB.substitute(ICMIB.dictionary[key], subs);
};

initNotificationBadge();
